import React, { useRef } from 'react';
import eureka from 'eureka';
import eurekaMgrs from '@eureka/ui-managers';
import { Button } from '@ui5/webcomponents-react';
import { ButtonDesign } from '@ui5/webcomponents-react';
import { MicroFrontendProps } from 'src/types';

const { useTranslation } = eureka.I18nProvider;
const { getConfig } = eurekaMgrs.ConfigManager;

type Props = Pick<MicroFrontendProps, 'eventBus'>;

const LogoutForm: React.FC<Props> = ({ eventBus }) => {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const { auth_provider, auth_method } = getConfig('user') || {};

  return (
    <div className="logout-form-container">
      <header className="header-container">
        <div>
          <h3>{t('Header_Confirmation')}</h3>
        </div>
      </header>
      <div className="content-container">
        <div>
          <form ref={formRef} action="/auth/logout" method="post">
            <input type="hidden" name="auth_provider" value={auth_provider} />
            <input type="hidden" name="auth_method" value={auth_method} />
          </form>
          {t('Header_Logout_Confirmation')}
        </div>
      </div>
      <footer className="footer-container">
        <Button
          style={{ padding: '0 9px' }}
          onClick={() => {
            eventBus.emit('dialog-show-hide', '', {
              type: 'cancel',
              data: {
                showDialog: false,
              },
            });
          }}
          design={ButtonDesign.Transparent}
        >
          {t('Header_Logout_Btn_No')}
        </Button>
        <Button
          style={{ marginLeft: '10px', padding: '0 9px' }}
          design={ButtonDesign.Emphasized}
          onClick={() => {
            if (formRef.current) {
              eventBus.emit('close-websocket', '', {
                type: 'logout',
                data: {},
              });
              setTimeout(() => {
                formRef.current?.submit();
              }, 2000);
              eventBus.emit('dialog-show-hide', '', {
                type: 'confirm',
                data: {
                  showDialog: false,
                },
              });
            }
          }}
        >
          {t('Header_Logout_Btn_Yes')}
        </Button>
      </footer>
    </div>
  );
};

export default LogoutForm;
